import { render, staticRenderFns } from "./ItemNote.vue?vue&type=template&id=6e53d594&scoped=true&"
import script from "./ItemNote.vue?vue&type=script&lang=js&"
export * from "./ItemNote.vue?vue&type=script&lang=js&"
import style0 from "./ItemNote.vue?vue&type=style&index=0&id=6e53d594&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e53d594",
  null
  
)

export default component.exports